import { render, staticRenderFns } from "./MessageBill.vue?vue&type=template&id=3b4cae4a&scoped=true&"
import script from "./MessageBill.vue?vue&type=script&lang=js&"
export * from "./MessageBill.vue?vue&type=script&lang=js&"
import style0 from "./MessageBill.vue?vue&type=style&index=0&id=3b4cae4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4cae4a",
  null
  
)

export default component.exports